var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShorts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.436 5.654A.783.783 0 0022.654 5H5.662a.783.783 0 00-.782.654L2.013 20.883a.787.787 0 00.625.915l8.106 1.649a.779.779 0 00.834-.392l2.424-4.37 2.424 4.37a.78.78 0 00.677.392h.157l8.106-1.649a.784.784 0 00.625-.889L23.436 5.654zM8.461 8.692H5.692l.285-1.846h2.485v1.846zm9.231 0h-7.384V6.846h7.384v1.846zm1.846 0V6.846h2.533l.237 1.846h-2.77z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgShorts;